import * as React from 'react';
import { toast } from 'react-toastify';
import ConfirmPopup from './ConfirmPopup';
import type { GenericList, ItemOptionList } from './models/JobSharedInterfaces';
import type { PriceListItem } from './models/AdminInterfaces';
import { PostQuery } from './Shared';

interface PricelistProps {
    systemCompanyId: number;
    id: number,
    priceListTierTypeId: number;
    itemList: ItemOptionList[];
    pricelist: PriceListItem[];
    customerOptions: GenericList[];
    frequencyList: GenericList[];
    locationList: GenericList[];
    metresList: GenericList[];
    isEpa: boolean;
    isPumpClean: boolean;
    isFencing: boolean;
    isFencingCustom: boolean;
    isEvent: boolean;
    isPriceOnly: boolean;
    update(pricelist: PriceListItem[]): void;
}

interface Pricelists {
    showDeleteConfirm: boolean;
    deleteIndex: number;
    errors: any;
    loading: boolean;
}

export default class Pricelist extends React.Component<PricelistProps, Pricelists> {
    constructor(props: PricelistProps) {
        super(props);
        this.state = {
            showDeleteConfirm: false,
            deleteIndex: -1,
            errors: {},
            loading: false
        }
    }

    handleCellChange = (e: any, itemIndex: number) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        var pricelist = this.props.pricelist;
        var pricelistItem = pricelist[itemIndex];

        let newPricelistItem: any = {};
        newPricelistItem = pricelistItem;
        newPricelistItem[e.target.name] = e.target.value * 1;
        newPricelistItem.isDirty = true;

        //if last row we need to add a new blank row
        let lastRow = pricelist.length - 1;
        if (itemIndex === lastRow) {
            var blankRow = this.addBlankRow(this.props.id, this.props.priceListTierTypeId);
            pricelist.push(blankRow);
        }
        this.setState({ errors: {} });
        this.props.update(pricelist);
    }

    handleBtmCheckboxChange = (e: any, itemIndex: number) => {
        var pricelist = [...this.props.pricelist];
        var pricelistItem = pricelist[itemIndex];

        pricelistItem.useBtm = e.target.checked;
        pricelistItem.isDirty = true;

        this.props.update(pricelist);
    }

    onItemCellChange = (e: any, itemIndex: number) => {
        var itemId = e.target.value * 1;

        var pricelist = this.props.pricelist;
        var pricelistItem = pricelist[itemIndex];
        pricelistItem.itemId = itemId;
        pricelistItem.isDirty = true;

        var itemOption = this.props.itemList.find(i => i.id === itemId);
        if (itemOption) {
            pricelistItem.baseDays = itemOption.priceListDefaultDays;
            pricelistItem.overhireRequired = itemOption.extendable;
            pricelistItem.itemTypeId = itemOption.typeId;
        }

        //if last row we need to add a new blank row
        let lastRow = pricelist.length - 1;
        if (itemIndex === lastRow) {
            var blankRow = this.addBlankRow(this.props.id, this.props.priceListTierTypeId);
            pricelist.push(blankRow);
        }

        this.setState({ errors: {} });
        this.props.update(pricelist)
    }

    addBlankRow = (id: number, typeId: number) => {
        var tierId = -1;
        var customerId = -1;
        if (typeId === 1) {
            tierId = id;
        } else {
            customerId = id;
        }

        let pricelistItem: PriceListItem = {
            id: 0,
            tierId: tierId,
            customerId: customerId,
            customerName: "",
            itemId: -1,
            itemTypeId: 0,
            hirePeriod: 0,
            frequencyId: -1,
            locationId: -1,
            metreId: -1,
            baseDays: 0,
            basePrice: 0,
            baseMetres: 0,
            useBtm: false,
            metreRate: 0,
            travelAmount: 0,
            baseAdditionalHireRate: 0,
            additionalHireRate: 0,
            extraHourRate: 0,
            overhireRequired: true,
            statusId: 1,
            isDirty: false
        };

        return pricelistItem;
    }

    //DELETE PRICELIST ITEM
    deleteItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        this.setState({ showDeleteConfirm: true, deleteIndex: itemIndex });
    }

    hideDeleteConfirm = () => {
        this.setState({ showDeleteConfirm: false, deleteIndex: -1 });
    }

    saveDeleteConfirm = () => {
        var pricelist = this.props.pricelist;
        var pricelistItem = pricelist[this.state.deleteIndex];

        if (pricelistItem.id === 0) {
            //just remove from the list as not saved
            pricelist.splice(this.state.deleteIndex, 1);
            this.setState({ showDeleteConfirm: false, deleteIndex: -1 });
            this.props.update(pricelist);
            toast.success("Item deleted successfully");
        } else {
            this.saveDeletePricelist(pricelist, pricelistItem.id);
        }
    }

    async saveDeletePricelist(pricelist: PriceListItem[], pricelistItemId: number) {
        var deletePriceList = {
            id: pricelistItemId
        };

        try {
            var jsonItem = JSON.stringify(deletePriceList);

            const apiUrl = "DeletePriceListItem";
            var result = await PostQuery(apiUrl, jsonItem);
            if (result.error) {
                toast.error("Error saving data!");
            } else {
                if (result.data.isError) {
                    var errorList = result.data.messages as any[];
                    errorList.map(function (error: any) {
                        toast.error(error.content);
                    });
                } else {
                    toast.success("Price List Saved Successfully");
                    pricelist.splice(this.state.deleteIndex, 1);
                    this.setState({ showDeleteConfirm: false, deleteIndex: -1 });
                    this.props.update(pricelist);
                }
            }
        } catch (e) {
            toast.error("Error saving customer!");
        }
    }
    //END DELETE PRICELIST ITEM

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        var itemList = this.props.itemList;
        var pricelist = this.props.pricelist;
        let lastRow = pricelist.length - 1;

        let confirmPopup = <ConfirmPopup heading="Delete Price List Item?" text="Are you sure you want to delete this price list item?" hideConfirmModal={this.hideDeleteConfirm} showConfirmModal={this.state.showDeleteConfirm} saveConfirmModal={this.saveDeleteConfirm} />

        return (
            <div>
                <div className="static-modal">
                    {confirmPopup}
                </div>
                <div className="overflowAuto">
                    <table className="table tableColours pricelist-width">
                        <thead>
                            <tr>
                                <th className="hidden">Id</th>
                                <th></th>
                                <th className={this.props.isFencingCustom ? "" : "hidden"}>Customer</th>
                                <th>Item</th>
                                <th className={this.props.isFencingCustom ? "" : "hidden"}>Hire Months</th>
                                <th className={this.props.isPumpClean ? "" : "hidden"}>Location</th>
                                <th className={this.props.isPumpClean || this.props.isEpa ? "" : "hidden"}>Maintenance</th>
                                <th className={this.props.isFencing ? "" : "hidden"}>Metres</th>
                                <th className={this.props.isEpa || this.props.isPumpClean || this.props.isEvent || this.props.isPriceOnly || this.props.isFencingCustom ? "hidden" : ""}>Base {this.props.isFencing ? "Months" : "Days"}</th>
                                <th className={this.props.isEpa || this.props.isFencing ? "" : "hidden"}>Base {this.props.isEpa ? "Litres" : "Metres"}</th>
                                <th>{this.props.isEpa || this.props.isPumpClean || this.props.isEvent || this.props.isPriceOnly ? "" : "Base"} Price</th>
                                <th className={this.props.isFencing ? "" : "hidden"}>Base Add. Hire Price</th>
                                <th className={this.props.isFencing ? "" : "hidden"}>Use BTM</th>
                                <th className={this.props.isEpa || this.props.isFencing ? "" : "hidden"}>{this.props.isEpa ? "Litre" : "Metre"} Rate</th>
                                <th className={this.props.isEvent || this.props.isPriceOnly ? "" : "hidden"}>Travel Amount</th>
                                <th className={this.props.isEpa || this.props.isPumpClean ? "hidden" : ""}>Additional Hire Rate</th>
                                <th className={this.props.systemCompanyId === 3 ? "hidden" : ""}>Extra Hours Rate</th>
                                <th></th>
                            </tr>
                        </thead>
                        {pricelist.map((item, index) =>
                            <tbody key={index}>
                                <tr>
                                    <td className="hidden">{item.id}</td>
                                    <td className="table__text--align">{index + 1}</td>
                                    <td className={this.props.isFencingCustom ? "table__text--align" : "hidden"}>
                                        <select className={item.id === 0 ? "select" : "hidden"} id="customerId" name="customerId" value={item.customerId} onChange={(e) => this.handleCellChange(e, index)}>
                                            <option defaultValue="-1"></option>
                                            {item.id === 0 ? this.props.customerOptions.map(customer =>
                                                <option key={customer.id} value={customer.id}>{customer.name}</option>
                                            ) : ""};
                                        </select>
                                        <span className={item.id === 0 ? "hidden" : ""}>{item.customerName}</span>
                                    </td>
                                    <td className="table__text--align">
                                        <select className="select" id="itemId" name="itemId" value={item.itemId} onChange={(e) => this.onItemCellChange(e, index)}>
                                            <option defaultValue="-1"></option>
                                            {itemList.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className={this.props.isFencingCustom ? "table__text--align" : "hidden"}>
                                        <input type='number' min="0" step="1" className="form-control textalignright" id="hirePeriod" name="hirePeriod" value={item.hirePeriod} onChange={(e) => this.handleCellChange(e, index)} />
                                    </td>
                                    <td className={this.props.isPumpClean ? "table__text--align" : "hidden"}>
                                        <select className={item.itemId === 81 ? "" : "hidden"} id="locationId" name="locationId" value={item.locationId} onChange={(e) => this.handleCellChange(e, index)}>
                                            <option defaultValue="-1"></option>
                                            {this.props.locationList.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className={this.props.isPumpClean || this.props.isEpa ? "table__text--align" : "hidden"}>
                                        <select className={item.itemTypeId === 47 || item.itemTypeId === 57 || item.itemTypeId === 58 || item.itemTypeId === 59 ? "hidden" : ""} id="frequencyId" name="frequencyId" value={item.frequencyId} onChange={(e) => this.handleCellChange(e, index)}>
                                            <option defaultValue="-1"></option>
                                            {this.props.frequencyList.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className={this.props.isFencing ? "table__text--align" : "hidden"}>
                                        <select className={item.itemTypeId === 50 ? "" : "hidden"} id="metreId" name="metreId" value={item.metreId} onChange={(e) => this.handleCellChange(e, index)}>
                                            <option defaultValue="-1"></option>
                                            {this.props.metresList.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className={this.props.isEpa || this.props.isPumpClean || this.props.isEvent || this.props.isPriceOnly || this.props.isFencingCustom ? "hidden" : "table__text--align"}>
                                        <input type='number' min="0" step="1" className="form-control textalignright" id="baseDays" name="baseDays" value={item.baseDays} onChange={(e) => this.handleCellChange(e, index)} disabled={!item.overhireRequired} />
                                    </td>
                                    <td className={this.props.isEpa || this.props.isFencing ? "" : "hidden"}>
                                        <input type='number' min="0" step="1" className={item.itemTypeId === 51 || item.itemTypeId === 60 ? "hidden" : "form-control textalignright"} id="baseMetres" name="baseMetres" value={item.baseMetres} onChange={(e) => this.handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className="form-control textalignright" id="basePrice" name="basePrice" value={item.basePrice} onChange={(e) => this.handleCellChange(e, index)} />
                                    </td>
                                    <td className={this.props.isFencing ? "table__text--align" : "hidden"}>
                                        <input type='number' min="0" step="0.01" className={item.metreId > 1 || !item.overhireRequired || item.itemTypeId === 51 ? "hidden" : "form-control textalignright"} id="baseAdditionalHireRate" name="baseAdditionalHireRate" value={item.baseAdditionalHireRate} onChange={(e) => this.handleCellChange(e, index)} />
                                    </td>
                                    <td className={this.props.isFencing ? "table__text--align textaligncenter" : "hidden"}>
                                        <input type='checkbox' className={item.itemTypeId === 50 && item.metreId === 1 ? "" : "hidden"} id="useBtm" name="useBtm" checked={item.useBtm} onChange={(e) => this.handleBtmCheckboxChange(e, index)} />
                                    </td>
                                    <td className={this.props.isEpa || this.props.isFencing ? "table__text--align" : "hidden"}>
                                        <input type='number' min="0" step="0.01" className={item.itemTypeId === 51 || item.itemTypeId === 60 ? "hidden" : "form-control textalignright"} id="metreRate" name="metreRate" value={item.metreRate} onChange={(e) => this.handleCellChange(e, index)} />
                                    </td>
                                    <td className={this.props.isEvent || this.props.isPriceOnly ? "table__text--align" : "hidden"}>
                                        <input type='number' min="0" step="0.01" className={item.itemTypeId === 31 || item.itemTypeId === 40 || item.itemTypeId === 53 ? 'form-control textalignright' : 'hidden'} id="travelAmount" name="travelAmount" value={item.travelAmount} onChange={(e) => this.handleCellChange(e, index)} />
                                    </td>
                                    <td className={this.props.isEpa || this.props.isPumpClean ? "hidden" : "table__text--align"}>
                                        <input type='number' min="0" step="0.01" className={item.overhireRequired ? "form-control textalignright" : "hidden"} id="additionalHireRate" name="additionalHireRate" value={item.additionalHireRate} onChange={(e) => this.handleCellChange(e, index)} />
                                    </td>
                                    <td className={this.props.systemCompanyId === 3 ? "hidden" : "table__text--align"}>
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="extraHourRate" name="extraHourRate" value={item.extraHourRate} onChange={(e) => this.handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <div className={index === lastRow ? "hidden" : "delete--tablecell"}>
                                            <a className="makeitred" href="#" onClick={(e) => this.deleteItem(e, index)}>
                                                <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                    {this.state.errors["pricelistitems"] ?
                        (this.state.errors["pricelistitems"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                </div>
            </div>
        )
    }

}




